<template>
	<el-container direction="vertical" class="login">
		<el-header>
			<div class="el-xlogo-container">
				<el-row :gutter="0">
					<el-col :span="12">
						<div>
							<el-image :src="xlogo" :style="logostyle">
								<div></div>
							</el-image>
						</div>
					</el-col>
				</el-row>
			</div>
			<div class="el-login-container">
				<div class="el-header-login">
					<el-tabs
					v-model="activeName"
					type="card"
					:stretch="true"
					@tab-click="getNewQr"
					>
						<el-tab-pane :label="$env == 'cn' ? '扫码登录': 'Code login'" name="login1">
							<div class="qrstyle">
								<div v-if="loadState ==0"> <!-- 加载中...  -->
									<div class="el-scaner-common line-height-60 padding-top-60">
										{{ $env == 'cn' ? '加载中...' : 'Loading...' }}
									</div>
								</div>
								<div v-if="loadState ==1"> <!-- 加载完毕...  -->
									<el-image :src="loginQr"></el-image>
								</div>
								<div v-if="loadState ==2"> <!-- 登录成功...  -->
									<div class="el-scaner-common padding-top-60">
										<div style="font-size: .875rem;color : #409EFF;">
											{{ $env == 'cn' ? '扫描成功' : 'Scan successfully' }}
										</div>
										<div style="font-size: .875rem;margin-top: 5px;">
											{{ $env == 'cn' ? '正在登录...' : 'Logging in...' }}
										</div>
									</div>
								</div>
								<div v-if="loadState ==3"> <!-- 二维码过期...  -->
									<div class="el-scaner-common padding-top-44">
										<el-image :src="qrExpired"></el-image>
										<div style="font-size: .875rem;">{{ $env == 'cn' ? '二维码已失效' : 'Expired' }}</div>
										<div style="font-size: .875rem;color : #409EFF;margin-top: 5px;cursor: pointer;"
											 data-name="login1"
											 @click="getNewQr({name: 'login1'})">
											{{ $env == 'cn' ? '点击刷新' : 'Refresh' }}
										</div>
									</div>
								</div>
								<div v-if="loadState ==4"> <!-- 登录失败  -->
									<div class="el-scaner-common padding-top-60">
										<el-image :src="qrExpired"></el-image>
										<div style="font-size: .875rem;">{{ $env == 'cn' ? '登录失败' : 'Login failed' }}
										</div>
										<div style="font-size: .875rem;color : #409EFF;margin-top: 5px;cursor: pointer;"
											 data-name="login1"
											 @click="getNewQr({name: 'login1'})">
											{{ $env == 'cn' ? '点击重试' : 'Click retry' }}
										</div>
									</div>
								</div>
							</div>
							<div class="el-login-notice" style="font-size: .875rem;">
								<span>{{ $env == 'cn' ? 'Xhorse APP 扫一扫' : 'Xhorse APP Scan' }}</span>
							</div>
							<!--<div class="mobile-scan">
								<el-image :src="mobile_scan"></el-image>
								<div class="mobile-scan-notice">Xhorse APP 扫一扫</div>
							</div>-->
						</el-tab-pane>
						<el-tab-pane :label="$env=='cn'?'账号密码登录':'Account login'" name="login2">
							<!--<el-row class="form-header">
								<el-col><div>账号密码登录</div></el-col>
							</el-row>-->
							<el-form
							ref="form"
							:model="loginForm"
							id="elx-loginer"
							:inline="false"
							label-position="left"
							label-width="55px"
							>
								<el-form-item size="medium" class="login-form-line"
											  :label="$env=='cn'?'地区':'Area'">
									<el-select v-model="loginForm.nationcode" class="login-code" filterable
											   :placeholder="$env=='cn'?'地区码':'Area'">
										<el-option
										v-for="item  in nationCode"
										:key="item.nation_code"
										:label="item.name+'('+item.nation_code+')'"
										:value="item.nation_code">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item size="medium" class="login-form-line"
											  :label="$env=='cn'?'用户名':'User'">
									<el-input
									v-model="loginForm.username"
									:placeholder="$env=='cn'?'用户名':'User'"
									class="login-user"
									:clearable="true"
									>
									</el-input>
								</el-form-item>
								<el-form-item size="medium" class="login-form-line"
											  :label="$env=='cn'?'密码':'Secret'">
									<el-input
									v-model="loginForm.password"
									:placeholder="$env=='cn'?'密码':'Secret'"
									type="password"
									class="login-pass"
									:clearable="true"
									>
									</el-input>
								</el-form-item>
								<el-form-item size="medium" class="" label="">
									<el-checkbox
									class="el-account-rem"
									v-model="loginForm.account"
									@change="accountRemember"
									>{{$env == 'cn' ? '记住密码' : 'Remember password'}}
									</el-checkbox>
								</el-form-item>
								<el-form-item class="el-submit-line el-submit-button"
											  style="width: 80%;margin-top: 0rem;">
									<el-button
									size="medium"
									class="el-submit-btn login-btn"
									:loading="loginLoading"
									@click="login($event)"
									>{{$env == 'cn' ? '登录' : 'Login'}}
									</el-button>
								</el-form-item>
							</el-form>
						</el-tab-pane>
					</el-tabs>
				</div>
				<div class="el-app-download">
					<el-row>
						<el-col :span="24" class="el-app-col">
							<el-image :src="appLogo" style="margin-right: 3rem;"></el-image>
							<div class="el-app-col-title" style="top: -1.75rem;">
								<a href="javascript:;"
								   target="_blank"
								   @click="appOpen"
								   :style="$env=='cn'?'':'display: inline-block;padding-left: 4.9375rem;'"
								   style="text-decoration: none;color: #409EFF;font-size: .875rem;padding-left: 4rem;">{{$env == 'cn' ? '下载APP' : 'Download APP'}}
								</a></div>
						</el-col>
					</el-row>
				</div>
			</div>
		</el-header>
		<el-footer>
			<div class="el-copy-right">
				Copyright 2019- Xhorse. All Rights Reserved
			</div>
		</el-footer>
	</el-container>
</template>

<script>
    import
    {
        loginIn,
        loginOut,
        valiLogin,
        customerCode,
        buildQrCode,
        webListener,
        webLogin,
        setCookie,
        getCookie,
        rmCookie
    } from '../../api/login';
    import {useGetter} from '../../api/local';
    import xlogo_cn from '../assets/logos/login_xhorse_cn.png';
    import xlogo_en from '../assets/logos/login_xhorse_en.png';
    import mobile_scan from '../assets/logos/mobile_scan.png';
    import loginbg from '../assets/images/loginbg.jpg';
    import appXhorse from '../assets/logos/btn_xhorse.png';
    import qrExpired from '../assets/logos/btn_remind.png';
    import ElImage from "../../node_modules/element-ui/packages/image/src/main";
    import ElLink from "../../node_modules/element-ui/packages/link/src/main";
    import ElOption from "../../node_modules/element-ui/packages/select/src/option";
    import ElFormItem from "../../node_modules/element-ui/packages/form/src/form-item";
    export default {
        components: {
            ElFormItem,
            ElOption,
            ElLink,
            ElImage
        },
        name: "login.vue",
        data: function () {
            const _this = this;
            return {
                activeName: 'login1',
                loginQr: "",
                mobile_scan: mobile_scan,
                qrNotification: _this.$env == 'cn' ? "加载中..." : "Loading...",
                loginForm: {
                    username: "",
                    password: "",
                    nationcode: _this.$env == 'cn' ? "中国(86)" : "United States(1)",
                    account: false
                },
                loginLoading: false,
                xlogo: _this.$env == 'cn' ? xlogo_cn : xlogo_en,
                appLogo: appXhorse,
                qrExpired: qrExpired,
                loadState: 0,
                logostyle: {
                    "width": "200%",
                    "height": "auto"
                },
                loadstyle: {
                    "width": "160px",
                    "position": "relative",
                    "top": "0px",
                    "left": "75px",
                    "text-align": "center"
                },
                nationCode: [],
                timerIntval: null
            }
        },
        methods: {
            accountRemember(val){

            },
            appOpen(){
                let iWidth = 600;
                let iHeight = 400;
                let iTop = (window.screen.availHeight - 30 - iHeight) / 2;
                //获得窗口的水平位置
                let iLeft = (window.screen.availWidth - 10 - iWidth) / 2;
                window.open("/appdl", "_blank", "toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=no, resizable=no, copyhistory=yes, width=" + iWidth + ", height=" + iHeight + ", left=" + iLeft + ", top=" + iTop + ",");
            },
            getNewQr(evt){
                const _this = this;
                _this.loadState = 0;
                _this.loginQr = "";
                clearInterval(_this.timerIntval);
                _this.timerIntval = null;
                if (evt.name == 'login1') {
                    buildQrCode().then(
                    function (res) {
                        console.log(res)
                        if (res.data && res.data.hasOwnProperty('uuid')) {
                            _this.loginQr = res.data.qrCode;
                            _this.loadState = 1;
                            const loginKey = res.data.uuid;
                            _this.timerIntval = setInterval(
                            function () {
                                webListener(loginKey).then(
                                (res) => {
                                    const loginInfo = res.data;
                                    if (loginInfo.status == 2019) {
                                        clearInterval(_this.timerIntval);
                                        _this.timerIntval = null;
                                        _this.loadState = 3;
                                    } else if (loginInfo.status == 2000) {
                                        clearInterval(_this.timerIntval);
                                        _this.timerIntval = null;
                                        _this.loadState = 2;
                                        // 登录成功
                                        const token = loginInfo.data.token;
                                        const mobile = loginInfo.data.mobile;
                                        const nationcode = _this.$env == 'cn' ? 86 : 1;
                                        webLogin(mobile, token, nationcode).then(
                                        function (res1) {
                                            if (res1 && parseInt(res1.data.status) == 2000) {
                                                clearInterval(_this.timerIntval);
                                                _this.timerIntval = null;
                                                _this.loadState = 2;
                                                setTimeout(function () {
                                                    const loginData = {
                                                        token: JSON.stringify(res1.data.data.token),
                                                        userid: res1.data.data.userid,
                                                        username: res1.data.data.username,
                                                        userheader: res1.data.data.userheader,
                                                        usercode: res1.data.data.nationcode,
                                                        userarea: res1.data.data.userarea
                                                    };
                                                    _this.$store.commit('xlogin', loginData);
                                                    //2) 跳转至首页
                                                    _this.$router.replace({
                                                        name: 'index', query: {
                                                            vpath: '/',
                                                            vmode: '1',
                                                            code: loginData['usercode']
                                                        }
                                                    });
                                                }, 2000);

                                            } else {
                                                clearInterval(_this.timerIntval);
                                                _this.timerIntval = null;
                                                _this.loadState = 4;
                                                return false;
                                            }
                                        }
                                        );
                                    } else if (loginInfo.status == 5000) {
                                        clearInterval(_this.timerIntval);
                                        _this.timerIntval = null;
                                        _this.loadState = 4;
                                        return false;
                                    }
                                }
                                );

                            },
                            3000
                            );

							/* 轮询 */
                        } else {
                            _this.$message.error(_this.$env == 'cn' ? '服务端异常，请稍后重试' : 'Server exception, please try again later');
                            return false;
                        }
                    }
                    );
                } else {
	                clearInterval(_this.timerIntval);
				}
            },
            login(evt){
				/*if (evt && evt.keyCode == 13) {
				 alert('ok');
				 }
				 return;*/
                const params = this.loginForm;
                const _this = this;
                if (params.nationcode == '') {
                    this.$message.error(_this.$env == 'cn' ? '请选择地区码' : 'Please select an area code');
                    return;
                }
                if (params.username == '') {
                    jQuery("div.login-user").find("input").focus();
                    this.$message.error(_this.$env == 'cn' ? '用户名不能为空' : 'Username can not be empty');
                    return;
                }

                if (params.password == '') {
                    jQuery("div.login-pass").find("input").focus();
                    this.$message.error(_this.$env == 'cn' ? '登录密码不能为空' : 'Login password cannot be empty');
                    return;
                }
                _this.loginLoading = true;
                params['nationcode'] = _this.$env == 'cn' ? 86 : 1;
                loginIn(params).then(
                function (response) {
                    if (response && parseInt(response.data.error) === 0 && parseInt(response.data.status) === 2000) {
						/*登录成功*/
                        //1) 记住密码
                        if (params.account === true) {
                            setCookie(params);
                        } else {
                            rmCookie();
                        }
                        //2) 记录登录状态
                        const loginData = {
                            token: JSON.stringify(response.data.data.token),
                            userid: response.data.data.userid,
                            username: response.data.data.username,
                            userheader: response.data.data.userheader,
                            usercode: response.data.data.nationcode,
                            userarea: response.data.data.userarea
                        };
                        _this.$store.commit('xlogin', loginData);
                        _this.$store.commit('xcodeset', isNaN(params.nationcode) ? (_this.$env == 'cn' ? 86 : 1) : params.nationcode);
                        //3) 跳转至首页
                        _this.$router.replace({
                            name: 'index', query: {
                                vpath: '/',
                                vmode: '1',
                                code: loginData['usercode']
                            }
                        });
                    } else {
                        _this.loginLoading = false;
                        _this.$alert(response.data.msg);
                    }
                }
                );
                return false;
            }
        },
        created() {

            //console.log(navigator.userAgent.toLowerCase());
            //验证用户是否登录
            const _this = this;
            const userInfo = useGetter();
            if (userInfo) {
                const username = userInfo.username;
                const nationcode = userInfo.usercode;
                const userarea = userInfo.userarea;
                valiLogin(username, nationcode).then(
                function (response) {
                    if (response && parseInt(response.data.error) === 0) {
                        _this.$router.replace({
                            name: 'index', query: {
                                name: '/',
                                vmode: 1,
                                code: loginData['usercode']
                            }
                        })
                    }
                }
                );
            }

            // 添加Enter登录事件
            document.onkeydown = function (e) {

                let key = window.event.keyCode;
                let dom = window.event.target
                console.log($(dom).parent().hasClass('login-user'))
                if (key == 13
                &&
                (
                $(dom).hasClass("login-btn") ||
                $(dom).parent().hasClass('login-pass') ||
                $(dom).parent().hasClass('login-user')
                )) {

                    _this.login();//登录的方法

                }

            };
            // 获取登录二维码
            _this.getNewQr({name: 'login1'});
            // 获取用户区号
            const lang = _this.$env == 'cn' ? 1 : 2;
            customerCode(lang).then(
            function (response) {
                _this.nationCode = response.data;
            }
            );
            // 获取已记住的密码
            const account = getCookie();
            if (
            account.hasOwnProperty('username')
            &&
            account.hasOwnProperty('password')
            ) {
                if (account.username && account.password) {
                    _this.loginForm.username = account.username;
                    _this.loginForm.password = account.password;
                    _this.loginForm.account = true;
                } else {
                    _this.loginForm.account = false;
                }
            }

        },
        mounted() {

            // 检测浏览器版本
            const browser = navigator.userAgent.toLowerCase();
            const _this = this;
            // 判断是否为小于IE11的浏览器
            if (browser.indexOf('compatible') > -1 && browser.indexOf('MSIE') > -1) {
                this.$confirm(
                _this.$env == 'cn' ? '你的浏览器不支持本网站的访问，请使用较高版本浏览器浏览。' : 'Your browser does not support access to this website, please use a higher version browser to browse.',
                {
                    confirmButtonText: _this.$env == 'cn' ? '确定' : 'determine',
                    type: 'warning'
                }
                ).then(
                function () {
                    window.close();
                    return;
                }
                );
            }
        }
    };
</script>

<style lang="css">
	@import "../assets/css/login/login.css";

	.el-header-login .form-header {
		width: 100%;
		margin-top: 1.25px;
		margin-bottom: .625rem;
		font-weight: 800;
		font-size: 1rem;
		text-align: left;
	}

	.el-submit-button {
		margin-top: -1.375rem;
	}

	.el-submit-button .el-form-item__content {
		width: 100%;
		left: 13%;
		margin-left: 0 !important;
	}
</style>
<style lang="css" scoped>
	.el-header .el-account-rem {
		text-align: left !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/login.vue